import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ConfirmationRequestFormBase } from '@bo-client/shared/base-components/confirmation-request-form.base';
import { Subject } from 'rxjs';
import { AuthenticationService } from '@bo-client/core';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { ErrorsFormsService } from '@bo-client/shared/form-errors/errors-forms.service';
import { CreateGridRegistrationFormsService } from '@bo-client/activation-management/grid-registration/create-grid-registration-forms.service';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';

@Component({
  selector: 'app-gr-confirm-feedin-order-form',
  templateUrl: './gr-confirm-feedin-order-form.component.html',
  styleUrls: ['./gr-confirm-feedin-order-form.component.scss']
})
export class GrConfirmFeedinOrderFormComponent
  extends ConfirmationRequestFormBase<GridRegistrationModel>
  implements OnInit, OnDestroy
{
  @Output() onErrorsChanged = new EventEmitter<any>();
  public compUnsubs$ = new Subject<void>();
  private gridRegistration: GridRegistrationModel;

  public constructor(
    protected authenticationService: AuthenticationService,
    protected dataShareService: DataShareService,
    protected errorsFormsService: ErrorsFormsService,
    protected createFormsGridRegistrationService: CreateGridRegistrationFormsService
  ) {
    super(authenticationService, dataShareService, errorsFormsService);
  }
  ngOnInit(): void {}

  loadFormWithModel(result: GridRegistrationModel) {
    this.gridRegistration = result;
    this.formGroup = this.createFormsGridRegistrationService.createGRFeedinOrderConfirmation();
  }

  hookErrors() {
    // entry Point to check specific errors
    console.log('emitting errors', this.errorFormList);
    this.onErrorsChanged.emit(this.errorFormList);
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
